module.exports = __webpack_public_path__ + "img/chevron-down.5a1178ef.svg";